import { Component, OnInit } from '@angular/core';
import { WantedItem, WantedStatus } from '../../models/wanted-item.model';
import { WantedItemService } from '../../services/wanted-item.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import {SaleStatus} from '../../models/automobilia.model';

@Component({
  selector: 'app-cars-wanted-management',
  templateUrl: './cars-wanted-management.component.html'
})
export class CarsWantedManagementComponent implements OnInit {

  public wantedItems: WantedItem[] = [];
  wantedItemToEdit: WantedItem;
  imagesToDelete: number[];

  files: File[];
  fileUrls: string[];
  fileMessage: string;

  wantedStatus = WantedStatus;
  selectedWantedStatus: WantedStatus;
  wantedItemToRemove: WantedItem;

  constructor(private wantedItemService: WantedItemService,
              public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
    this.wantedItemService.wantedItem.subscribe(wantedItems => this.wantedItems = wantedItems);
  }

  editWantedItem(wantedItem: WantedItem) {
    this.wantedItemToEdit = {...wantedItem};
  }

  removeWantedItem(wantedItem: WantedItem) {
    this.wantedItemService.deleteWantedItem(wantedItem).then(result => {
      // console.log('result:', result);
      this.wantedItemToEdit = null;
    }, error => {
      console.log('error:', error);
      this.wantedItemToEdit = null;
    });
  }

  createNewWantedItem() {
    this.wantedItemToEdit = new WantedItem(null, '', '', true, []);
  }

  saveWantedItem(wantedItem: WantedItem) {
    if (this.imagesToDelete) {
      this.wantedItemService.deleteWantedItemImages(this.wantedItemToEdit.id, this.imagesToDelete).then(() => {
        this.imagesToDelete = null;
      });
    }

    this.wantedItemService.saveWantedItem(wantedItem).then((savedWantedItem: WantedItem) => {
      if (savedWantedItem) {
        if (this.files) {
          this.wantedItemService.saveWantedItemFiles(savedWantedItem, this.files).then((resultSavedFiles) => {
            this.files = null;
            this.fileUrls = null;
            this.fileMessage = null;
          });
        }
        this.wantedItemToEdit = null;
      }
    }, error => {
      console.log('error:', error);
      this.wantedItemToEdit = null;
    });
  }

  setWantedItemStatus(wantedItem: WantedItem, wantedStatus: WantedStatus) {
    wantedItem.wantedStatus = wantedStatus;
    this.saveWantedItem(wantedItem);
  }

  cancel() {
    this.wantedItemToEdit = null;
    this.imagesToDelete = null;
    this.files = null;
    this.fileUrls = null;
  }

  onFileChanged(event) {
    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) === null) {
      this.fileMessage = 'Only images are supported.';
      return;
    }

    this.files = Array.from(event.target.files);
    this.files.forEach((file, index) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (readerEvent) => {
        if (!this.fileUrls) {
          this.fileUrls = [];
        }
        this.fileUrls.push(reader.result.toString());
      };
    });
  }

  removeTempFile(deleteFile, deleteIndex) {
    this.files = this.files.filter(file => file !== deleteFile);
    this.fileUrls = this.fileUrls.filter((fileUrl, index) => index !== deleteIndex);
  }

  removeExistingFile(deleteImage, deleteIndex) {
    this.wantedItemToEdit.images = this.wantedItemToEdit.images.filter(image => image !== deleteImage);
    if (!this.imagesToDelete) {
      this.imagesToDelete = [];
    }
    this.imagesToDelete.push(deleteImage.id);
  }

  toggleFilter(wantedStatus: WantedStatus) {
    this.selectedWantedStatus = (this.selectedWantedStatus !== wantedStatus) ? wantedStatus : null;
  }


}
